import firebase from 'firebase/compat/app';
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/analytics";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_authDomain,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASEURL,
  projectId: process.env.REACT_APP_FIREBASE_projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_appId,
  measurementId: process.env.REACT_APP_FIREBASE_measurementId
}

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const db = firebase.firestore();
export const firebaseAuth = firebase.auth;
export const storage = firebase.app().storage("gs://manejebem-app.appspot.com");
export const analytics = firebase.analytics();
export const dbtimestamp = firebase.firestore.Timestamp.now()

export async function initFirebaseAnalytics(event_name, params) {
  console.log({
    event_name, 
    params 
  })

  const firebaseAnalytics = await firebase.analytics().logEvent(event_name, params);

  return firebaseAnalytics;
}
